<!-- 上传图纸 -->
<template>
    <el-dialog title="上传图纸" :visible.sync="visible" width="500px" :before-close="handleCloseDialog">
        <el-form :model="ruleForm2" status-icon ref="ruleForm2" label-width="110px" class="demo-ruleForm">
            <el-form-item label="平面监控名称" prop="name"
            :rules="{ required: true, message: '请输入监控名称', trigger: 'blur' }">
                <el-input v-model.number="ruleForm2.name"></el-input>
            </el-form-item>
            <el-form-item label="上传平面图" prop="imageUrl"
            :rules="{ required: true, message: '请上传图片', trigger: 'change' }">
                <el-upload
                    class="avatar-uploader"
                    :action="UploadUrl"
                    name="image"
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="handleAvatarSuccess"
                    :on-progress="uploadVideoProcess"
                    :headers="headers"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="ruleForm2.imageUrl" :src="ruleForm2.imageUrl" class="avatar" id="img_avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <el-progress v-if="videoUploadPercent>0&&videoUploadPercent<100" type="circle" :percentage="videoUploadPercent" class="upload-progress"></el-progress>
                    <div slot="tip" class="el-upload__tip">图片大小不能超过2M！</div>
                </el-upload>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Service from '@/api/Service'
import config from '@/config'
import Storage from '@/utils/storage'
export default {
    name:  'CmpTcsUpload',
    props: ["visible", "name"],
    data() {
        return {
            ruleForm2: {
                name: '',
                imageUrl: '',
            },
            isEdit: false,
            UploadUrl: config.UPLOAD_URL,
            videoUploadPercent: 0,

      };
    },
    watch: {
        name(newVal) {
            if(newVal != '监控设置') {
                this.ruleForm2.name = newVal;
                this.isEdit = true;
            }
        }
    },
    computed: {
        headers() {
            let token = Storage.get('token');
            if (token) {
                return { Authorization: token.token };
            }else{
                return {}
            }
        }
    },
    mounted() {
        
    },

    methods: {
        handleAvatarSuccess(res, file) {
            this.videoUploadPercent = 100;
            if(res.status == 20001000) {
                this.ruleForm2.imageUrl = config.DEFAULT_FILE_PATH + res.data;
            }else{
                this.$message.error(res.message);
            }
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        uploadVideoProcess(event, file, fileList){
            this.videoUploadPercent = file.percentage.toFixed(0);
        },
        // 关闭弹框
        handleCloseDialog() {
            this.$emit("handleCloseDialog", {flag: false});
        },
        // 确认选择
        handleSave() {
            if(this.isEdit) {
                let data
                if(this.ruleForm2.imageUrl != '') {
                    let w_img = document.getElementById('img_avatar').naturalWidth || 600;
                    let h_img = document.getElementById('img_avatar').naturalHeight || 600;
                    data = Object.assign({},this.ruleForm2,{ w_img, h_img })
                    this.$emit("handleCloseDialog", {flag: true, data: data});
                    return false;
                }
                data = Object.assign({},this.ruleForm2)
                this.$emit("handleCloseDialog", {flag: true, data: data});
                return false;
            }
            this.$refs['ruleForm2'].validate((valid) => {
                if (valid) {
                    let w_img = document.getElementById('img_avatar').naturalWidth || 600;
                    let h_img = document.getElementById('img_avatar').naturalHeight || 600;
                    
                    let data = Object.assign({},this.ruleForm2,{ w_img, h_img })
                    
                    this.$emit("handleCloseDialog", {flag: true, data: data});
                } else {
                    return false;
                }
            });
            
        },
    }
}

</script>
<style lang='less'>
    
        
    .upload-progress{
        position: absolute;
        z-index: 99;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        background-color: #fff;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 150px;
        height: 150px;
        line-height: 150px;
        text-align: center;
    }
    .avatar {
        width: 150px;
        height: 150px;
        display: block;
    }
</style>